import { useState } from 'react'

// Galería de imágenes de un lote. Mostrar la primera grande,
// con miniaturas para navegar. Si no hay imágenes, placeholder.
export default function ImageGallery({ images = [], title = '' }) {
  const [active, setActive] = useState(0)
  const list = Array.isArray(images) ? images : []

  if (list.length === 0) {
    return <div className="gallery gallery-empty" aria-label="Kein Bild verfügbar">🖼️</div>
  }

  const current = list[active]

  return (
    <div className="gallery">
      <div className="gallery-main">
        <img src={current.image_url || current} alt={title} loading="eager" />
      </div>
      {list.length > 1 && (
        <div className="gallery-thumbs" role="tablist" aria-label="Bilder">
          {list.map((img, i) => (
            <button
              key={i}
              type="button"
              className={`gallery-thumb ${i === active ? 'is-active' : ''}`}
              onClick={() => setActive(i)}
              aria-label={`Bild ${i + 1}`}
            >
              <img src={img.image_url || img} alt="" loading="lazy" />
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
